import { Component } from '@angular/core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'ciao-roles-permissions',
  templateUrl: './roles-permissions.component.html',
  styleUrls: ['./roles-permissions.component.less'],
  standalone: false,
})
export class RolesPermissionsComponent {
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  open = {
    typesOfRoles: true,
    permissionsByRole: true,
    permissionsByTeamRole: true,
  };

  toggle(key: keyof typeof this.open) {
    this.open[key] = !this.open[key];
  }
}
